import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import ProfileSwitchTabs from "./ProfileSwitchTabs";

import { base_url } from "../../../../config";
import verifyIcon from "../../../../assets/verified-icon.svg";
import notVerifyIcon from "../../../../assets/not-verified-icon.svg";
import availableIcon from "../../../../assets/available-icon.svg";
import notAvailableIcon from "../../../../assets/not-available-icon.svg";

import { API_BASE_URL } from "../../../../config";
import { getAuthToken, getAdminAuthToken } from "../../../../auth/auth";

import { profileImgSrc } from "../../../../config";

export default function ProfileCard({ details }) {
  console.log("details", details);
  const [availability, setAvailability] = useState(
    details.profile.availability
  );
  const [isLoading, setIsLoading] = useState(false);

  const tokenAdmin = getAdminAuthToken();

  const handleToggleAvailability = async (e) => {
    const token = getAuthToken() || tokenAdmin;
    const newAvailability = e.target.checked;
    const previousAvailability = availability; // zapamti staru vrijednost

    // Optimistic UI update
    setAvailability(newAvailability ? 1 : 0);
    setIsLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/employee/toggle-availability`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            availability: newAvailability,
            employee_id: details.id,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || data.success === false) {
        // VRATI NA STARU VRIJEDNOST
        setAvailability(previousAvailability);

        // PRIKAZI ERROR PORUKU
        toast.error(
          data.message || "Failed to change availability. Please try again."
        );

        setIsLoading(false);
        return;
      }

      // SUCCESS MESSAGE (ako želiš)
      toast.success(data.message || "Availability updated.");
    } catch (error) {
      // U slučaju network error-a
      setAvailability(previousAvailability); // vrati switch
      toast.error("Network error. Please try again.");
    }

    setIsLoading(false);
  };

  let avatar;

  if (details?.profile.avatar !== null) {
    avatar = `${base_url}${details.profile.avatar}`;
  } else {
    avatar = `${profileImgSrc}`;
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="profile-card-wrapper">
        <div className="profile-img">
          <img
            src={
              details.profile.avatar instanceof File
                ? URL.createObjectURL(details.profile.avatar)
                : avatar
            }
            alt="profile-img"
          />
        </div>
        <div className="profile-info">
          <div className="profile-info__header">
            <div className="profile-name-wrapper">
              <div className="profile-name">
                <h4>
                  {details.name}
                  {details.profile.verified === 1 ? (
                    <img src={verifyIcon} alt="verified" />
                  ) : (
                    <img src={notVerifyIcon} alt="not verified" />
                  )}
                </h4>
                <p>{details.profile.current_role}</p>
              </div>
            </div>
            <div className="profile-availability-wrapper">
              {availability === 0 ? (
                <p>
                  <img src={notAvailableIcon} alt="available" />
                  Not available for work
                </p>
              ) : (
                <p>
                  <img src={availableIcon} alt="available" />
                  Available for work
                </p>
              )}
              <div
                className={`change-availability ${isLoading ? "disabled" : ""}`}
              >
                <label>
                  <input
                    type="checkbox"
                    checked={availability === 1}
                    onChange={handleToggleAvailability}
                  />
                  <span></span>
                </label>
              </div>
            </div>
          </div>
          <ProfileSwitchTabs details={details} />
        </div>
      </div>
    </>
  );
}
